export const MAX_RETRY_COUNT = 20;
export const MAX_RETRY_INTERVAL = 5000;
export const MAX_RETRY_DELIVERY_INTERVAL = 15000;
export const MAX_WAIT_DELIVERY_INTERVAL = 180000;
